import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Price } from 'bricks';
import * as SharedZoneProductGoods from 'store/SharedZone/blocks/goods/selectors';
import commonStyles from 'styles/common.pcss';

const cx = classNames.bind({ ...commonStyles });

function GoodsDayInfo({ title, href, value, oldValue, className, onClick }) {
  return (
    <div className={className} onClick={onClick} role="link" tabIndex="0">
      <a href={href}>{title}</a>
      <div className={cx('marb-m', 'mart-m')}>
        <Price level={3} value={value} oldValue={oldValue} />
      </div>
    </div>
  );
}

GoodsDayInfo.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string,
  value: PropTypes.number,
  oldValue: PropTypes.number,
  onClick: PropTypes.func,
};

const mapStateToProps = (state) => ({
  title: SharedZoneProductGoods.getTitle(state),
  href: SharedZoneProductGoods.getUrl(state),
  value: SharedZoneProductGoods.getPrice(state),
  oldValue: SharedZoneProductGoods.getOldPrice(state),
});

export default SharedZoneProductGoods.connect(mapStateToProps)(GoodsDayInfo);
